export * from './lib/two-columns-layout/two-columns-layout.component';
